module.exports = __webpack_public_path__ + "img/section3-2.44bc5069.png";